export const texts = {
  copyright: `Działanie współfinansowane ze środków Unii Europejskiej, w ramach
        Europejskiego Funduszu Rozwoju Regionalnego, Program Operacyjny Polska
        Wschodnia, oś priorytetowa I: Przedsiębiorcza Polska Wschodnia,
        działanie 1.1 Platformy Startowe dla nowych pomysłów; poddziałanie
        1.1.1 Platformy startowe dla nowych pomysłów.`,
  registeredSuccessfully: `Gratulacje, rejestracja powiodła się! Na podany adres mailowy
        wysłaliśmy wiadomość z linkiem aktywacyjnym. Aby aktywować konto
        kliknij w link w wiadomości.`,

  accountAcitivationLinkSent: `Na adres mailowy podany podczas rejestracji wysłaliśmy linkaktywacyjny`,
  accountActivationLinkSentInfo: `Sprawdź skrzynkę mailową (wiadomość mogła trafić do folderu SPAM)`,
  passwordResetLinkSent: `Jeżeli podałeś poprawny adres mailowy to na Twoją skrzynkę pocztową
        została wysłana wiadomość z linkiem do zrestartowania hasła.`,
  passwordChanged: `Twoje hasło zostało pomyślnie zmienione. Możesz się teraz zalogować korzystając 
        z nowego hasła.`,
};

export default texts;
